const USAGE_SHARE_DISPLAY_DECIMALS = 1;

const SMALLEST_DISPLAYED_USAGE_SHARE = 0.1;

// The row and the sparkline tooltip render the same quantity, so both must floor it identically.
export const formatUsageShare = (sharePercent: number, usageCount: number): string => {
  const roundedShare = sharePercent.toFixed(USAGE_SHARE_DISPLAY_DECIMALS);

  return Number(roundedShare) === 0 && usageCount > 0
    ? `<${SMALLEST_DISPLAYED_USAGE_SHARE}%`
    : `${roundedShare}%`;
};
